import { render, staticRenderFns } from "./SlotClosureDialogShell.vue?vue&type=template&id=39c74852"
import script from "./SlotClosureDialogShell.vue?vue&type=script&lang=js"
export * from "./SlotClosureDialogShell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports